import { promosFailure, promosRequest, promosSuccess } from './actions';
import { PROMOS_REQUEST_ERROR } from '../../constants/notifications';
import { resolveSearchPromosPage } from '../../services/promosSearch';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TQueryString } from '../../types/queryString';
import { TThunkAction } from '../../types/redux/thunk';
import { trackNewPageAction } from '../analytics';
import { setError } from '../error';

interface IParameters {
  queryString?: TQueryString;
  jsonQuery?: IJsonQuery;
}

export const promosRequestByParamsAction =
  (parameters: IParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { config, logger, httpApi, custom }) => {
    const subdomain = custom.subdomain;

    try {
      dispatch(promosRequest());

      const data = await resolveSearchPromosPage({
        config,
        httpApi,
        logger,
        subdomain,
        queryString: parameters?.queryString,
        jsonQuery: parameters?.jsonQuery,
      });

      dispatch(promosSuccess(data));
      dispatch(trackNewPageAction());
    } catch (e) {
      dispatch(promosFailure());

      dispatch(setError({ id: Date.now(), message: PROMOS_REQUEST_ERROR }));
    }
  };
